export const getOriginalLevel = (contentLevels, language) => {
  if (language) {
    return contentLevels.find(
      (level) => level.is_original_level && level.language === language,
    );
  }

  return contentLevels.find((level) => level.is_original_level);
};
